export interface UseGameAssetParameters {
    slug: string | null | undefined
    vendor_slug: string | null | undefined
    provider_slug: string | null | undefined
    updated_at: string | null | undefined
}

export enum GameAssetTypes {
    LOGO = 'game_logo',
    LOGO_AFTER = 'game_logo_after',
    TILE = 'game_tile',
    TILE_AFTER = 'game_tile_after',
    FEATURED_LOGO = 'featured_game_logo',

    ICON = 'game_icon',
    ICON_AFTER = 'game_icon_after',
    SYMBOL = 'game_symbol',

    VIDEO = 'game_video',
    VIDEO_POSTER = 'game_video_poster',
    VIDEO_SMALL = 'game_video_small',
    VIDEO_SMALL_POSTER = 'game_video_small_poster',

    HERO_VIDEO = 'game_hero_video',
    HERO_VIDEO_POSTER = 'game_hero_video_poster',

    HERO_BACKGROUND = 'hero_background',
}

export type GameAssetTypesUnion = `${GameAssetTypes}`
